import { WSCard, WSList, WSText } from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";
import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayablesSummary } from "../../../query/payables/useQueryPayablesSummary";
import { FilterableTablePayables } from "../components/TablePayables/FilterableTablePayables";
import { createListRequest } from "../components/TablePayables/filters/request";

export const RoutePayablesToPreApprove: React.FC = () => {
  useBrowserPageTitle("Payables To Pre-Approve");
  const userId = useUserId();
  const history = useHistory();

  const draftRequest = createListRequest(userId, undefined, undefined, "draft");
  const queryPayablesDraftSummary = useQueryPayablesSummary(draftRequest);
  const draftCount = queryPayablesDraftSummary.data?.listSize ?? 0;

  return (
    <WSList gap="2XL">
      {draftCount > 0 && (
        <WSCard
          header={{
            label: {
              avatar: {
                type: "icon",
                icon: "alert-circle",
                size: "M",
                color: "amber400",
                colorBackground: "amber50"
              },
              text: "Draft payables"
            }
          }}
          divider="bottom"
          actions={{
            alignment: "left",
            buttons: [
              {
                label: "Manage draft payables",
                kind: "Link",
                rightIcon: "chevron-right",
                onClick: () => {
                  history.push("/member/invoices/payables/draft");
                }
              }
            ]
          }}
        >
          <WSText.ParagraphSm color="gray500">
            {draftCount} draft payable{draftCount > 1 ? "s" : ""}.
          </WSText.ParagraphSm>
        </WSCard>
      )}

      <FilterableTablePayables
        tab="to-preapprove"
        showDownloadCsv
        bulkActions={["preapprove", "cancel"]}
        featuredBulkAction="PreApprove"
        visibleColumns={{
          payee: true,
          payableNumber: true,
          amount: true,
          dueDate: true,
          openedAt: true,
          status: true
        }}
        visibleFilters={{
          payeeId: true,
          openedDateRange: true,
          dueDateRange: true
        }}
        emptyState={{
          firstTime:
            "Every requested, scheduled, and paid payable will display here.",
          standart:
            "You're all caught up! Nothing is waiting for your pre-approval."
        }}
      />
    </WSList>
  );
};
